export default "__VITE_PUBLIC_ASSET__2a0e41f6__"